export default "__VITE_ASSET__08a2adb0__"